import type { FilterKey } from '@library/types/filters';
import type { SelectOption } from '@library/types/utils';
import { Tab } from '@library/components/buttons';
import { useEffect } from 'react';

export interface TabFilterProps {
  disabled?: boolean;
  filterClassName?: string;
  filterName: FilterKey;
  handleSelect: (value: string) => void;
  options: Array<SelectOption>;
  selectedValue: string;
  tabActiveClassName?: string;
  tabClassName?: string;
  testId?: string;
}

export const TabFilter = ({
  disabled = false,
  filterClassName = '',
  filterName,
  handleSelect,
  options,
  selectedValue,
  tabActiveClassName = '',
  tabClassName = '',
  testId = 'tab-filter'
}: TabFilterProps) => {
  const selectedValueNotInOptions = !options.find(
    (option) => option.value === selectedValue
  );

  useEffect(() => {
    if ((!selectedValue || selectedValueNotInOptions) && options.length) {
      handleSelect(options[0].value);
    }
  }, [
    selectedValue,
    options,
    filterName,
    handleSelect,
    selectedValueNotInOptions
  ]);

  if (!options.length) {
    return null;
  }

  const handleClick = (value: string) => {
    handleSelect(value);
  };

  const durationTabs = options.map((option) => {
    const { name, value } = option;
    const active = value === selectedValue;

    return (
      <Tab
        active={active}
        className={active ? tabActiveClassName : tabClassName}
        disabled={disabled}
        handleClick={handleClick}
        id={value}
        key={value}
        size="small"
        tabName={name}
      />
    );
  });

  return (
    <div className={filterClassName} data-testid={testId}>
      {durationTabs}
    </div>
  );
};
